module.exports = __webpack_public_path__ + "static/media/cost-category.1bed016a.png";